import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ErrorPageComponent } from '@reg/error-page/error-page.component';

const errorPageRoutes: Routes = [
    {
        path: '',
        component: ErrorPageComponent,
    },
    {
        path: ':error-id',
        component: ErrorPageComponent,
    },
];

@NgModule({
    imports: [
        RouterModule.forChild(errorPageRoutes),
    ],
    exports: [RouterModule],
})
export class ErrorPageRoutingModule {
}
